module.exports = "https://trybtryb-legacy.web.app/img/header.7343645c.svg";